import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { NavLink } from 'react-router-dom';
import SelectAsync from 'react-select/async';
import UserCard from "../UserCard";

export default class Support extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            message: '',
            supportUserId: this.getDefaultGuid(),
            attachmentFileName: '',
            attachment: ''
        }
    }
    componentDidMount() {
        var userId = this.getDefaultGuid();
        var querParams = window.location.href.split("?");
        if (querParams.length > 1) {
            var params = querParams[1].split("&");
            params.forEach(p => {
                if (p.split("=")[0].toLowerCase() == "user") userId = p.split("=")[1];
            });
        }
        this.httpPost("api/v1/support/get", {
            id: this.getCurrentFormId(),
            userId: userId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/support/save", {
            id: this.getCurrentFormId(),
            status: this.state.data.record.status,
            topic: this.state.data.record.topic,
            userId: this.state.data.record.userId,
            message: this.state.message,
            supportUserId: this.state.supportUserId,
            attachmentFileName: this.state.attachmentFileName,
            attachment: this.state.attachment
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/supports/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    closeTicket() {
        this.httpPost("api/v1/support/close", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("تیکت با موفقیت بسته شد");
                    this.setState({
                        redirect: '/supports/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setAttachment(_file) {
        this.getBase64(_file).then(file => {
            this.state.attachment = file;
            this.state.attachmentFileName = _file.name;
        });
    }
    loadUsersOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getusers/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name + ' - ' + _record.mobile
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    onShowUserCard(id) {
        this.showComponents({ component: <UserCard Caller={this} Id={id} /> });
    }
    showJsonMessage(msg) {
        var content = JSON.parse(msg.message);
        return <div></div>
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="row g-4 mb-4">
                                    {!this.isEmpty(this.state.data.messages) && <div>
                                        {this.state.data.messages.map(msg => <div className={"col-lg-12 alert alert-pro " + (!msg.isAdmin ? "alert-warning rtl" : "alert-success rtl")}>
                                            {this.isBlank(msg.userId) ? <h6>{msg.userName}</h6> :
                                                <h6><a className="hand" onClick={e => this.onShowUserCard(msg.userId)} title="مشاهده کارت عملکرد کاربر"><em className="icon ni ni-info"></em></a> <a href={this.getSiteDomain() + "/user/" + msg.userId + "/"}>{msg.userName}</a></h6>}
                                            {(msg.messageFormat === 0 || msg.messageFormat === 1) && <div dangerouslySetInnerHTML={{ __html: msg.message }}></div>}
                                            {msg.messageFormat === 2 && this.showJsonMessage(msg)} 
                                            <div>
                                                <small>تاریخ {msg.date}</small>
                                                {!this.isBlank(msg.attachmentPath) && <a style={{ "margin-right": "10px" }} target="_blank" href={msg.attachmentPath}>مشاهده فایل پیوست</a>}
                                            </div>
                                        </div>)}
                                    </div>}
                                </div>
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">محتوای پیام</h5>
                                        </div>
                                        <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                            {this.state.data.record.id === this.getDefaultGuid() && <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">موضوع</label>
                                                    <div className="form-control-wrap">
                                                        <select className="form-control" defaultValue={this.state.data.record.topic} onChange={e => this.state.data.record.topic = parseInt(e.target.value)}>
                                                            <option value="0">انتخاب موضوع</option>
                                                            <option value="1">مشاوره آموزش</option>
                                                            <option value="2">مشاوره حضوری با مدیریت</option>
                                                            <option value="3">مربیگری - تدریس</option>
                                                            <option value="4">اختلال در خرید</option>
                                                            <option value="5">گواهینامه</option>
                                                            <option value="6">درخواست استخدام</option>
                                                            <option value="7">درخواست نیروی کار</option>
                                                            <option value="8">سایر موارد</option>
                                                            <option value="9">اختلال در سامانه مودیان</option>
                                                            <option value="10">نیاز / اختلال در ماژولهای مالی و اداری</option>
                                                            <option value="11">رزومه</option>
                                                            <option value="12">پرسش و سوال</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>}
                                            {this.state.data.record.id === this.getDefaultGuid() && <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">کاربر عضو</label>
                                                    <div className="form-control-wrap">
                                                        {this.state.data.record.userId !== this.getDefaultGuid() ? this.state.data.toUserName :
                                                            <SelectAsync
                                                                defaultValue={null}
                                                                isMulti={false}
                                                                placeholder="انتخاب کاربر عضو"
                                                                defaultOptions
                                                                loadOptions={this.loadUsersOptions}
                                                                onChange={e => this.state.data.record.userId = e.value}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>}
                                            <div className="col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label">ارجاع به همکار</label>
                                                    <div className="form-control-wrap">
                                                        <select className="form-control" type="text" defaultValue={this.state.supportUserId} onChange={e => this.state.supportUserId = e.target.value}>
                                                            <option value="0">ارجاع نشود</option>
                                                            {this.state.data.users.map(p => <option value={p.id}>{p.fname} {p.lname}</option>)}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">پیام شما</label>
                                                    <div className="form-control-wrap">
                                                        <textarea className="form-control" type="text" defaultValue={this.state.message} onChange={e => this.state.message = e.target.value}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">فایل پیوست</label>
                                                    <div className="form-control-wrap">
                                                        <input type="file" onChange={(e) => { this.setAttachment(e.target.files[0]) }} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-lg btn-primary">ارسال پیام</button>
                                                    {this.state.data.record.id !== this.getDefaultGuid() && <a onClick={e => this.closeTicket()} className="ms-2 btn btn-lg btn-danger">بستن تیکت</a>}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}